import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const Cursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const rx = useSpring(x, { stiffness: 260, damping: 24, mass: 0.6 });
  const ry = useSpring(y, { stiffness: 260, damping: 24, mass: 0.6 });

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    setEnabled(true);
    document.body.classList.add("custom-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) =>
      setActive(!!e.target.closest("a, button, select, input, textarea, [role='button']"));
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      document.body.classList.remove("custom-cursor");
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        data-testid="cursor-dot"
        className="pointer-events-none fixed left-0 top-0 z-[90] h-2 w-2 rounded-full bg-cyan-300"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
      />
      <motion.div
        className={`pointer-events-none fixed left-0 top-0 z-[90] rounded-full border transition-[width,height,border-color,background-color] duration-300 ${
          active
            ? "h-14 w-14 border-cyan-300/70 bg-cyan-400/10"
            : "h-9 w-9 border-cyan-400/40"
        }`}
        style={{ x: rx, y: ry, translateX: "-50%", translateY: "-50%" }}
      />
    </>
  );
};
